export default __webpack_public_path__ + "64463488474049922f534c0199b8ab1d.png";